import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CompanyInfo from './components/CompanyInfo';
import LocationsSection from './components/LocationsSection';
import SEOHead from '../../components/SEO/SEOHead';
import StructuredData from '../../components/SEO/StructuredData';

const AziendaPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://agro-innovazioni.it';
  
  const aboutPageData = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'Chi Siamo - AGRO-INNOVAZIONI S.r.l',
    description: 'Scopri la storia di AGRO-INNOVAZIONI, azienda specializzata in spezie biologiche e biscotti da tisana. Qualità e sostenibilità dal cuore dell\'Italia.',
    url: `${siteUrl}/azienda`,
    mainEntity: {
      '@type': 'Organization',
      name: 'AGRO-INNOVAZIONI S.r.l',
      description: 'Azienda specializzata in spezie biologiche di alta qualità e biscotti biologici da tisana',
      url: siteUrl,
      logo: 'https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/f44ef6b76bca892c4b2b8ad1895f9c04.jpeg',
      foundingDate: '2010',
      address: [
        {
          '@type': 'PostalAddress',
          streetAddress: 'Via Example 123',
          addressLocality: 'Milano',
          addressRegion: 'MI',
          postalCode: '20100',
          addressCountry: 'IT',
        },
        {
          '@type': 'PostalAddress',
          streetAddress: 'Via Example 456',
          addressLocality: 'Sassuolo',
          addressRegion: 'MO',
          postalCode: '41049',
          addressCountry: 'IT',
        },
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+39-0230310856',
        contactType: 'customer service',
        availableLanguage: ['Italian', 'English'],
      },
      sameAs: [
        'https://www.instagram.com/agroinnovazioni',
        'https://www.facebook.com/agroinnovazioni',
      ],
    },
  };

  return (
    <>
      <SEOHead
        title="Chi Siamo - AGRO-INNOVAZIONI S.r.l | Spezie e Biscotti Biologici"
        description="Scopri la storia di AGRO-INNOVAZIONI, azienda specializzata in spezie biologiche e biscotti da tisana. Qualità e sostenibilità dal cuore dell'Italia."
        keywords="AGRO-INNOVAZIONI, azienda bio, spezie biologiche Milano, biscotti biologici, storia azienda"
        ogTitle="Chi Siamo - AGRO-INNOVAZIONI S.r.l | Spezie e Biscotti Biologici"
        ogDescription="Scopri la storia di AGRO-INNOVAZIONI, azienda specializzata in spezie biologiche e biscotti da tisana. Qualità e sostenibilità dal cuore dell'Italia."
        ogImage="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/f44ef6b76bca892c4b2b8ad1895f9c04.jpeg"
        ogType="website"
        canonical={`${siteUrl}/azienda`}
      />
      <StructuredData type="AboutPage" data={aboutPageData} />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main className="pt-20">
          <CompanyInfo />
          <LocationsSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default AziendaPage;
